import { Injectable } from "@angular/core";
import { Http, Headers, Response } from "@angular/http";
import { environment } from '../../../environments/environment';
import "rxjs/add/operator/toPromise";

import { Club } from "../../_models/clubs.model";
import { Staff } from "../../_models/staff.model";

import { ActivityLogItem } from "../../_models/activityLogItem.model";

import * as moment from 'moment';

@Injectable()
export class ClubsService {
    constructor(private http: Http) { }

    list(id) {
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("access_token", currentUser.access_token);

        return this.http.get(environment.apiUrl + id + "/clubs", {
            headers: headers
        })
            .toPromise()
            .then((res: Response) => {
                let data = res.json();
                let allClubs = [];

                console.log(data);

                data.data.forEach((entry) => {
                    let club = new Club();
                    club.name = entry.name;
                    club.id = entry.RecordID;
                    allClubs.push(club);
                });

                return allClubs;
            })
            .catch(this.handleError);
    }
    get(id: number) {

        function checkRole() {
            // create authorization header with jwt token
            let currentUser = JSON.parse(localStorage.getItem('currentUser'));
            console.log(currentUser);
            if (currentUser && currentUser.userdata.email == "kzeiger@lifegait.com") {
                return "associationadmin";
            } else {
                return "associationadmin";
            }
        }


        let headers = new Headers();
        headers.append("Content-Type", "application/json");

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        console.log(currentUser);
        if (currentUser && currentUser.access_token) {
            console.log("has token");
            headers.append("access_token", currentUser.access_token);
        }

        return this.http.get(environment.apiUrl + "club/" + id, {
            headers: headers
        })
            .toPromise()
            .then((res: Response) => {
                let data = res.json();
                let club = new Club();
                club.name = data.data.name;
                club.id = data.data.club_id;
                club.phone = data.data.phone;
                club.email = data.data.email;
                club.image_path = data.data.image_path;

                club.compliance_count = parseInt(data.data.total_compliant);
                //club.athlete_count = data.data.athlete_count;
                club.athlete_count =  parseInt(data.data.total_count);
                club.staff_count = data.data.staff_count;
                club.team_count = data.data.team_count;
                club.removed_count = data.data.removed_count;
                club.removed_pending_count = data.data.removed_pending_count;

                var is_compliant = false;

                if (club.compliance_count >= club.athlete_count) {
                    is_compliant = true;
                }

                club.compliant = is_compliant;

                let clubStaff = [];
                if (data.data.admin && data.data.admin[0]) {
                    data.data.admin.forEach((staffItem) => {
                        let staff = new Staff();
                        staff.id = staffItem.staff_id;
                        staff.first_name = staffItem.staff_first_name;
                        staff.last_name = staffItem.staff_last_name;
                        staff.email = staffItem.staff_email;
                        staff.phone = staffItem.staff_phone;
                        staff.role_title = staffItem.role_title;
                        clubStaff.push(staff);
                    });
                }

                club.staff = clubStaff;

                club.admin_name = '';
                if (data.data.admin && data.data.admin[0]) {
                    if (data.data.admin[0].role_title) club.admin_title = data.data.admin[0].role_title;
                    club.admin_name = data.data.admin[0].admin_first_name + " " + data.data.admin[0].admin_last_name;
                    if (data.data.admin[0].admin_email) club.admin_name = data.data.admin[0].admin_email;
                    if (data.data.admin[0].admin_phone) club.admin_name = data.data.admin[0].admin_phone;
                }


                console.log('admins', data.data.admin);
                club.removed = false;

                if (data.data.removed_count > 0) {
                    club.removed = true;
                }



                /*  
                  data.types.forEach((eachType) => {
                    club.types.push(eachType.type.name);
                  });
              
                  data.stats.forEach((eachStat) => {
                    club.stats.push({
                      name: eachStat.stat.name,
                      value: eachStat.base_stat
                    });
                  });
                  */

                return club;
            })
            .catch(this.handleError);
    }

    getActivityLog(id: number) {


        let headers = new Headers();
        headers.append("Content-Type", "application/json");

        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        console.log(currentUser);
        if (currentUser && currentUser.access_token) {
            console.log("has token");
            headers.append("access_token", currentUser.access_token);
        }

        return this.http.get(environment.apiUrl + "club/" + id + "/activity", {
            headers: headers
        })
            .toPromise()
            .then((res: Response) => {
                let data = res.json();
                let activityList = [];

                console.log(data);

                data.data.forEach((entry) => {
                    let activity_log_item = new ActivityLogItem();

                    /*
                      id: number;
                      staff_id_fk: number;
                      activity_timestamp: string;
                      admin_first_name: string;
                      admin_last_name: string;
                      role_type_title: string;
                      athlete_log_type_label: string;
                      activity_log_type_id_fk: number;
                    */

                    activity_log_item.id = entry.activity_log_id;

                    activity_log_item.activity_timestamp = entry.activity_timestamp;

                    activity_log_item.athlete_first_name = entry.athlete[0].athlete_first_name;
                    activity_log_item.athlete_last_name = entry.athlete[0].athlete_last_name;

                    activity_log_item.activity_timestamp_date = moment(entry.activity_timestamp).format("MM/DD/YY");
                    activity_log_item.activity_timestamp_time = moment(entry.activity_timestamp).format("h:mm a");

                    activity_log_item.staff_id_fk = entry.staff_id_fk;
                    activity_log_item.athlete_id_fk = entry.athlete_id_fk;
                    if (activity_log_item.staff_id_fk) {
                        activity_log_item.admin_first_name = entry.staff[0].admin_first_name;
                        activity_log_item.admin_last_name = entry.staff[0].admin_last_name;
                        activity_log_item.role_type_title = entry.staff[0].role_type_title;
                    }

                    activity_log_item.athlete_log_type_label = entry.athlete_log_type[0].athlete_log_type_label;
                    activity_log_item.activity_log_type_id_fk = entry.activity_log_type_id_fk;
                    activityList.push(activity_log_item);
                });

                return activityList;
            })
            .catch(this.handleError);
    }

    listClubStaff(id) {
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("access_token", currentUser.access_token);

        return this.http.get(environment.apiUrl + "sgadmin/club/" + id + "/staff", {
            headers: headers
        })
            .toPromise()
            .then((res: Response) => {
                let data = res.json();
                let clubStaff = [];

                console.log(data);

                data.data.forEach((entry) => {
                    let staff = new Staff();
                    staff.first_name = entry.first_name;
                    staff.last_name = entry.last_name;
                    staff.email = entry.email;
                    staff.phone = entry.phone;
                    staff.reset_token = entry.reset_token;
                    staff.staff_id = entry.staff_id;
                    staff.role_slug = entry.role_slug;
                    clubStaff.push(staff);
                });

                return clubStaff;
            })
            .catch(this.handleError);
    }

    /*
      private jwt() {
            // create authorization header with jwt token
            let currentUser = JSON.parse(localStorage.getItem('currentUser'));
            console.log(currentUser);
            if (currentUser && currentUser.access_token) {
                console.log("has token");
                //let headers = new Headers({ 'Authorization': 'Bearer ' + currentUser.access_token });
                let headers = new Headers({ 'access_token': currentUser.access_token });
                return new RequestOptions({ headers: headers });
            }
        }
      */


    private handleError(error: Response | any) {
        let errMsg: string;
        if (error instanceof Response) {
            const body = error.json() || "";
            const err = body.error || JSON.stringify(body);
            errMsg = `${error.status} - ${error.statusText || ""} ${err}`;
        } else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Promise.reject(errMsg);
    }
}


// WEBPACK FOOTER //
// ./src/app/_services/association/clubs-service.ts